import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import useLocalStorage from '../../hooks/useLocalStorage'

const CustomSection = ({
  setTemplates,
  setSelectedSectionSlugs,
  setFocusedSectionSlug,
  setAddAction,
}) => {
  const [showModal, setShowModal] = useState(false)
  const [title, setTitle] = useState('')
  const inputRef = useRef(null)
  const { saveBackup } = useLocalStorage()

  const addCustomSection = () => {
    if (!title.trim()) return

    const slug = `custom-${title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')}`

    const section = {
      slug,
      name: title,
      markdown: `## ${title}\n\n`,
    }

    setTemplates((prev) => {
      const updated = [...prev, section]
      saveBackup(updated)
      return updated
    })

    setSelectedSectionSlugs((prev) => [...prev, slug])
    setFocusedSectionSlug(slug)
    setAddAction(true)

    setTitle('')
    setShowModal(false)
  }

  return (
    <>
      {/* Modal */}
      <Transition show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={inputRef}
          onClose={setShowModal}
        >
          <div className="fixed inset-0 bg-black/40" aria-hidden="true" />

          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Dialog.Panel className="w-full max-w-md rounded bg-white p-6 shadow">
              <Dialog.Title className="text-lg font-semibold">
                Add Custom Section
              </Dialog.Title>

              <input
                ref={inputRef}
                className="mt-4 w-full border rounded p-2"
                placeholder="Section title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />

              <div className="mt-6 flex justify-end gap-2">
                <button
                  className="px-4 py-2 bg-gray-200 rounded"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-emerald-500 text-white rounded disabled:opacity-50"
                  disabled={!title.trim()}
                  onClick={addCustomSection}
                >
                  Add Section
                </button>
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Transition>

      {/* Trigger Button */}
      <button
        className="w-full py-2 mt-2 border rounded hover:bg-gray-100"
        onClick={() => setShowModal(true)}
      >
        ➕ Add Custom Section
      </button>
    </>
  )
}

export default CustomSection
